var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailoredYou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 49.201 49.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.6 -1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24949",
    "data-name": "Path 24949",
    d: "M22.372,18H15.457A3.457,3.457,0,0,0,12,21.457V35.286a3.457,3.457,0,0,0,3.457,3.457h6.914a3.457,3.457,0,0,0,3.457-3.457V21.457A3.457,3.457,0,0,0,22.372,18ZM15.457,35.286V21.457h6.914V35.286Z",
    transform: "translate(7.286 11.658)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24950",
    "data-name": "Path 24950",
    d: "M12.372,21H5.457A3.457,3.457,0,0,0,2,24.457V33.1a3.457,3.457,0,0,0,3.457,3.457h6.914A3.457,3.457,0,0,0,15.829,33.1V24.457A3.457,3.457,0,0,0,12.372,21ZM5.457,33.1V24.457h6.914V33.1Z",
    transform: "translate(0 13.843)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24951",
    "data-name": "Path 24951",
    d: "M32.372,13H25.457A3.457,3.457,0,0,0,22,16.457V38.929a3.457,3.457,0,0,0,3.457,3.457h6.914a3.457,3.457,0,0,0,3.457-3.457V16.457A3.457,3.457,0,0,0,32.372,13ZM25.457,38.929V16.457h6.914V38.929Z",
    transform: "translate(14.572 8.015)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24952",
    "data-name": "Path 24952",
    d: "M6.738,27.929a1.74,1.74,0,0,0,.427-.054,72.84,72.84,0,0,0,17.706-7.087A72.7,72.7,0,0,0,41.31,8.09v4.282a1.729,1.729,0,1,0,3.457,0V3.729A1.729,1.729,0,0,0,43.038,2H34.4a1.729,1.729,0,1,0,0,3.457h4.626A69.189,69.189,0,0,1,23.177,17.779,69.343,69.343,0,0,1,6.311,24.52a1.729,1.729,0,0,0,.427,3.409Z",
    transform: "translate(2.177 0)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailoredYou);
export default __webpack_public_path__ + "static/media/tailored-you.fefcab222e5ba18748cd69e6018ab668.svg";
export { ForwardRef as ReactComponent };